"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _ramda = require("ramda");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _fileListing = _interopRequireDefault(require("./file-listing"));

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var propTypes = {
  /** setting for column sizes */
  columnPropotions: _propTypes.string,

  /** File text */
  fileTitle: _propTypes.string,

  /** Files list data */
  files: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    /** filename of each filter group */
    fileName: _propTypes.string.isRequired,

    /** Glyph node */
    glyph: _propTypes.node.isRequired,

    /** Tag for filter group */
    tag: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func]),

    /** URL of each filter group */
    url: _propTypes.string.isRequired
  })),

  /** Title color */
  titleColor: _propTypes.string
};
var filesGridStyles = {
  alignItems: "center",
  columns: [6, 3, 3],
  justifyContent: "center",
  mt: [5, 0, 0, 0, 0],
  position: "relative"
};
var font = {
  fontSize: 3,
  fontWeight: 1,
  lineHeight: [2, 2, 2, 2, 2, 2],
  textAlign: "left"
};
var titleTextStyles = {
  fontSize: [2, 2, 2, 2, 2, 2],
  fontWeight: 2,
  lineHeight: [3, 3, 3, 3, 3, 3],
  textAlign: "left"
};
var titleContainerStyles = {
  px: [3, 3, 3, 3, 3],
  py: [2, 4, 2, 2, 2]
};
var FileBack = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "files__FileBack",
  componentId: "sc-j8bf9e-0"
})(["background-color:", ";border-radius:12px;box-shadow:0 0 8px ", ",0 4px 8px ", ";letter-spacing:0.5px;position:relative;"], function (props) {
  return (0, _styles.colors)("background", props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.5, "border")(props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.5, "border")(props);
});
FileBack.displayName = "Modules.FileBack";

var Files = function Files(_ref) {
  var columnPropotions = _ref.columnPropotions,
      fileTitle = _ref.fileTitle,
      files = _ref.files,
      titleColor = _ref.titleColor;
  return /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Element, _extends({}, filesGridStyles, {
    py: columnPropotions === "one-whole" ? 4 : 0
  }), /*#__PURE__*/_react["default"].createElement(FileBack, {
    flexDirection: "column",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, titleContainerStyles, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    color: titleColor
  }, titleTextStyles), fileTitle)), (0, _ramda.map)(function (_ref2) {
    var tag = _ref2.tag,
        glyph = _ref2.glyph,
        url = _ref2.url,
        fileName = _ref2.fileName;
    return /*#__PURE__*/_react["default"].createElement(_fileListing["default"], {
      key: url,
      font: Object.assign({
        color: titleColor
      }, font),
      glyph: glyph,
      tag: tag,
      url: url
    }, fileName);
  }, files)));
};

Files.propTypes = propTypes;
Files.displayName = "Modules.Files";
var _default = Files;
exports["default"] = _default;